import type { GetRolesApiArg } from '../../state/api/axilon-v2-api.generated'
import { pinEnum } from '../utils/pin-enum'

type Source = GetRolesApiArg['product'][number]

export const Product = {
  Devops: 'devops',
  Ontology: 'ontology'
} as const
export type Product = (typeof Product)[keyof typeof Product]

pinEnum<Product, Source>()
